import { ModelType, ModelTypeID } from '../../api';
import { AssistantChats2026 } from '../assistant2026';
import React from 'react';

export const CommunistPartySecretaryChatsNew = () => {
    return <AssistantChats2026 modelType={ModelType.ASSISTANT_2026} modelTypeId={ModelTypeID.ASSISTANT_2026} />;
};
